import api from './api';

export type TakedownStatus =
  | 'draft'
  | 'contact_resolved'
  | 'pending_approval'
  | 'approved'
  | 'sent'
  | 'acknowledged'
  | 'resolved'
  | 'rejected'
  | 'failed';

export interface TakedownRequest {
  id: number;
  company_id: number;
  event_id: number | null;
  target_url: string;
  target_domain: string | null;
  channel: string;
  abuse_contact_email: string | null;
  abuse_contact_source: string | null;
  notice_subject: string | null;
  notice_body: string | null;
  status: TakedownStatus;
  last_error: string | null;
  created_at: string | null;
  approved_at: string | null;
  sent_at: string | null;
  resolved_at: string | null;
}

const BASE = '/api/v2/takedowns';

export async function listTakedowns(params?: { status_filter?: TakedownStatus }): Promise<TakedownRequest[]> {
  const res = await api.get(`${BASE}/`, { params });
  return res.data;
}

export async function getTakedown(id: number): Promise<TakedownRequest> {
  const res = await api.get(`${BASE}/${id}`);
  return res.data;
}

export async function createTakedown(body: { target_url: string; event_id?: number; company_id?: number }): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/`, body);
  return res.data;
}

export async function resolveContact(id: number): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/${id}/resolve-contact`);
  return res.data;
}

export async function updateNotice(id: number, body: { notice_subject?: string; notice_body?: string; abuse_contact_email?: string }): Promise<TakedownRequest> {
  const res = await api.patch(`${BASE}/${id}`, body);
  return res.data;
}

export async function submitForApproval(id: number): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/${id}/submit-for-approval`);
  return res.data;
}

export async function approveAndSend(id: number): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/${id}/approve-and-send`);
  return res.data;
}

export async function rejectTakedown(id: number): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/${id}/reject`);
  return res.data;
}

export async function markResolved(id: number): Promise<TakedownRequest> {
  const res = await api.post(`${BASE}/${id}/mark-resolved`);
  return res.data;
}
